<template>
  <div class="page" id="video-post">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" background-color="#EBF9FF"
      color="#02B99E">
    </loading>
    <div class="decorative-texture top">
      <img src="../assets/img/texture.png" />
    </div>
    <div class="decorative-texture position-bottom movil-only">
      <img src="../assets/img/texture.png" />
    </div>
    <vue-snotify></vue-snotify>

    <mnavbar @menuVisible="menuVisible" :v-if="on"></mnavbar>
    <side-menu :menuOn="menuOn" @menuVisible="menuVisible"></side-menu>

    <email-alert :show="emailModal" :subject="item.titulo" @enviar="sendEmail" @cancelarEnviar="cancelarEnviar"
      @error="error"></email-alert>
    <section>
      <div class="container-fluid">
        <div class="w80">
          <div class="row">
            <div class="col-12 col-sm-12 col-md-6">
              <div class="text-center">
                <span class="sub" v-if="markI && markF">Duración recorte: {{ calcular_timpo_recorte() }}</span>
              </div>
              <div class="video-controls" v-if="playing">
                <span class="sub" v-if="markI > 0">{{
                  mostrar_minutos(markI)
                  }}</span>
                <button class="button backward-button tooltip tooltip-top" data-tooltip="Marca Inicial"
                  @click="setMarkIni()">
                  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 28 28"
                    style="enable-background: new 0 0 28 28" xml:space="preserve">
                    <g id="adelantar" transform="translate(-234.672 -170.642)">
                      <path id="Trazado_312"
                        d="M239.0628052,172.3892212c-0.9644623,0-1.7463074,0.7818451-1.7463074,1.7463074l0,0v20.9646454
                                 c0,0.9649506,0.7822571,1.7472076,1.7472076,1.7472076s1.7472076-0.7822571,1.7472076-1.7472076v-20.9646454
                                 c0-0.9644623-0.7818451-1.7463074-1.7463074-1.7463074C239.0640106,172.3892212,239.0634003,172.3892212,239.0628052,172.3892212z" />
                      <path id="Trazado_313" d="M256.2006836,171.4100952l-11.0599518,11.0635223
                                 c-0.0233459,0.0197754-0.1652985,0.1455231-0.1796722,0.1652832c-0.4154205,0.4053497-0.6499329,0.9610596-0.6503601,1.5414886
                                 c0.001358,0.5491028,0.2069092,1.0780945,0.5767365,1.4840088l11.3402252,12.2169495
                                 c0.4156494,0.4539337,1.0014954,0.7143097,1.6169434,0.7186432c1.2054443-0.0019836,2.1818848-0.9792328,2.1828613-2.1846924
                                 v-23.5912933c0.0064697-1.1986084-0.9599915-2.1755066-2.1585999-2.1819763
                                 C257.2265625,170.6385498,256.6156616,170.9198151,256.2006836,171.4100952z" />
                    </g>
                  </svg>
                </button>
                <button class="button forward-button tooltip tooltip-top" @click="setMarkFin()"
                  data-tooltip="Marca Final">
                  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 28 28"
                    style="enable-background: new 0 0 28 28" xml:space="preserve">
                    <g id="adelantar" transform="translate(-234.672 -170.642)">
                      <path id="Trazado_312"
                        d="M258.281189,196.8527679c0.964447,0,1.7463074-0.7818451,1.7463074-1.7463074l0,0v-20.9646454
                                 c0-0.9649506-0.7822571-1.7472076-1.7472229-1.7472076c-0.9649353,0-1.7471924,0.7822571-1.7471924,1.7472076v20.9646454
                                 c0,0.9644623,0.7818604,1.7463074,1.7463074,1.7463074C258.2799988,196.8527679,258.2805786,196.8527679,258.281189,196.8527679z" />
                      <path id="Trazado_313" d="M241.1433105,197.8318939l11.0599518-11.0635376
                                 c0.0233459-0.0197601,0.1652985-0.1455078,0.1796722-0.1652679c0.4154205-0.4053497,0.6499329-0.9610596,0.6503601-1.5415039
                                 c-0.001358-0.5491028-0.2069092-1.0780792-0.5767365-1.4840088l-11.34021-12.2169495
                                 c-0.4156647-0.4539185-1.0014954-0.7142944-1.6169434-0.7186279c-1.2054596,0.0019684-2.1818848,0.9792328-2.1828766,2.1846771
                                 v23.5913086c-0.0064697,1.1985931,0.9599915,2.1755066,2.1585846,2.1819763
                                 C240.1174316,198.6034393,240.7283173,198.3221741,241.1433105,197.8318939z" />
                    </g>
                  </svg>
                </button>
                <span class="sub" v-if="markI > 0">{{
                  mostrar_minutos(markF)
                  }}</span>
                <button class="button cut-button tooltip tooltip-top" data-tooltip="Cortar Video" @click="cut()">
                  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 28 28"
                    style="enable-background: new 0 0 28 28" xml:space="preserve">
                    <path id="cortar"
                      d="M27.5514641,22.0027504l-14.2679672-7.9880047l14.2679672-7.9880042
                                c0.4217873-0.2353954,0.5728874-0.7681475,0.3374939-1.1899352c-0.0316334-0.0566831-0.0694809-0.1096683-0.1128407-0.1579762
                                c-1.6343002-1.8160791-4.4313011-1.9464116-7.302042-0.3429804l-1.0409451,0.5779214
                                c-3.2137241,1.7869258-7.6158733,4.2289433-9.0220909,5.9146895c-0.2951612,0.3559341-0.5612545,0.7350025-0.7957134,1.1335487
                                l-3.2017183-1.7937841c2.4050522-0.9544353,3.5810108-3.6778388,2.6265755-6.082891S5.3623447,0.5043239,2.9572923,1.4587591
                                s-3.5810106,3.6778381-2.6265755,6.0828905c0.387687,0.9769211,1.0926015,1.7951088,2.0014284,2.3230381
                                C2.356154,9.8801212,2.3647285,9.9075603,2.388737,9.921279l6.214798,3.4795322
                                c0.0240088,0.1371918,0.0651665,0.3429794,0.1371927,0.6156492c-0.0703115,0.2640944-0.113184,0.4767418-0.135478,0.6139336
                                l-6.214797,3.4761028c-0.0240088,0.0137196-0.0342979,0.0411568-0.0565917,0.056591
                                c-2.2171836,1.2967854-2.9633136,4.1454201-1.6665283,6.3626041s4.1454201,2.9633121,6.3626037,1.6665287
                                c2.2171831-1.2967854,2.9633131-4.1454201,1.6665287-6.3626041c-0.5213356-0.8913555-1.3244891-1.5838585-2.2828569-1.9683495
                                l3.2017183-1.793787c0.234458,0.3985462,0.5005512,0.7776146,0.7957134,1.1335487
                                c1.4062185,1.6874619,5.8083668,4.1294804,9.0220909,5.9112606l1.0409451,0.5779209
                                c2.8707409,1.6051464,5.6591702,1.4748135,7.302042-0.3429794c0.3226433-0.3594685,0.2927933-0.9124279-0.0666733-1.2350731
                                c-0.0483112-0.0433578-0.1012936-0.0812054-0.15798-0.1128387V22.0027504z M4.6661243,8.1823711
                                c-1.289021,0-2.3339789-1.0449581-2.3339791-2.3339791c0-1.289021,1.0449576-2.3339787,2.3339787-2.3339789
                                c1.2890205,0,2.3339791,1.0449579,2.3339791,2.3339784C6.999157,7.1370206,5.9547534,8.1814241,4.6661243,8.1823711z
                                  M7.000103,22.1828136c0,1.2890205-1.0449586,2.3339787-2.3339791,2.3339787s-2.3339787-1.0449581-2.3339787-2.3339787
                                c0.0000002-1.2890205,1.0449579-2.3339787,2.3339787-2.3339787C5.9547529,19.8497791,6.999157,20.8941841,7.000103,22.1828136z" />
                  </svg>
                </button>
                <button class="button tooltip tooltip-top" data-tooltip="Deshacer Cambios" v-if="changeOrigen"
                  @click="undoVideoCut()">
                  <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="undo" role="img"
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path
                      d="M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z">
                    </path>
                  </svg>
                </button>
              </div>
              <div ref="containerVideo" class="video" v-if="activeVideo">
                <video-player ref="videoNota" v-if="item.entrada == 'Y'" class="vjs-custom-skin"
                  :options="playerOptions"></video-player>
                <video-player v-else ref="videoNota" class="vjs-custom-skin" :options="playerOptions"
                  @ready="playerReadied" @playing="onPlayerPlaying"></video-player>
              </div>
              <div class="video touchpad" :style="{
                'background-image': 'url(' + thumb + ')',
                'background-size': '100%',
                'background-position': 'center',
              }" @click="playVideo" v-else>
                <button class="play-button secondary touchpad">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-play">
                    <polygon points="5 3 19 12 5 21 5 3"></polygon>
                  </svg>
                </button>
              </div>
              <!-- video touchpad -->
              <div class="row actions align-items-center">
                <div class="col">
                  <div class="button-container">
                    <button :class="[
                      'button',
                      'small',
                      'tooltip',
                      'tooltip-bottom',
                      'accion-video',
                      { active: like },
                    ]" data-tooltip="Positiva" @click="saveLike(1)">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round">
                        <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 
                                            2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 
                                            2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
                      </svg>
                      <span></span>
                    </button>
                    <button :class="[
                      'button',
                      'small',
                      'tooltip',
                      'tooltip-bottom',
                      'accion-video',
                      { active: dislike },
                    ]" data-tooltip="Negativa" @click="saveLike(0)">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round">
                        <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 
                                        2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 
                                        2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17" />
                      </svg>
                      <span></span>
                    </button>
                    <button :class="[
                      'button',
                      'small',
                      'tooltip',
                      'tooltip-bottom',
                      'accion-video',
                      { active: meh },
                    ]" data-tooltip="Informativa" @click="saveLike(2)">
                      <svg fill="currentColor" aria-hidden="true" focusable="false" stroke="currentColor"
                        data-prefix="fas" data-icon="info-circle" class="svg-inline--fa fa-info-circle fa-w-16"
                        role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path
                          d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z">
                        </path>
                      </svg>
                      <span></span>
                    </button>
                  </div>
                  <!-- button-container -->
                </div>
                <!-- col -->
                <div class="col-auto">
                  <div class="calificacion">
                    <div class="stars">
                      <button :data-tooltip="getTooltip(i)" v-for="i in 4" :key="i" :class="stars[i - 1]"
                        @click="saveStars(i)" @mouseover="pintaStars(i)" @mouseleave="rollbackStars()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                          <path
                            d="M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417 5.388 2.833-8.718-7.416-5.389h9.167z" />
                        </svg>
                      </button>
                      <button class="button small tooltip tooltip-bottom star-video" data-tooltip="Capturar Imagen"
                        @click="takeSnap()" v-if="item.entrada == 'T' && playing">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="feather feather-camera">
                          <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z">
                          </path>
                          <circle cx="12" cy="13" r="4"></circle>
                        </svg>
                      </button>
                    </div>
                    <!-- stars -->
                  </div>
                  <!-- calificacion -->
                </div>
                <!-- col-auto -->
              </div>
              <!-- row actions align-items-center -->
            </div>
            <!-- col-sm-12 col-md-5-->

            <div class="col-sm-12 col-md-6">
              <div class="row align-items-center">
                <div class="col">
                  <div class="user-avatar" v-if="item.noticiero">
                    <div class="img-avatar" :style="{
                      'background-image':
                        'url(' +
                        item.noticiero.imagen +
                        '),url(' +
                        defaultImage +
                        ')',
                    }"></div>
                    <div class="data-avatar">
                      <p class="user-name touchpad noticieroName" ref="noticiero-post" @mouseover="setTooltip"
                        @mouseleave="removeTooltip" @click="goToNotes">
                        {{ item.noticiero.nombre }}
                        <span class="tooltipLabel" v-if="tooltip">Escaleta</span>
                      </p>
                      <p class="user" v-if="item.entrada == 'T' || item.entrada == 'R'">
                        {{ item.nombre_canal }} / {{ item.senal_canal }}
                      </p>
                      <a class="user" :href="item.media" target="_blank" v-else>{{ item.media }}</a>
                    </div>
                  </div>
                </div>
                <div class="col-auto">
                  <svg class="svgPD" v-if="item.entrada == 'T'" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="30px" height="30px"
                    viewBox="0 0 24 24">
                    <path
                      d="M8.16,3L6.75,4.41L9.34,7H4C2.89,7 2,7.89 2,9V19C2,20.11 2.89,21 4,21H20C21.11,21 22,20.11 22,19V9C22,7.89 21.11,7 20,7H14.66L17.25,4.41L15.84,3L12,6.84L8.16,3M4,9H17V19H4V9M19.5,9A1,1 0 0,1 20.5,10A1,1 0 0,1 19.5,11A1,1 0 0,1 18.5,10A1,1 0 0,1 19.5,9M19.5,12A1,1 0 0,1 20.5,13A1,1 0 0,1 19.5,14A1,1 0 0,1 18.5,13A1,1 0 0,1 19.5,12Z" />
                  </svg>
                  <svg class="svgPD" v-if="item.entrada == 'R'" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="30px"
                    height="30px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                    <path
                      d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-.47 1.29L16.7 22h-2.13L12 14.93L9.43 22H7.3l3.17-8.71A2 2 0 0 1 10 12a2 2 0 0 1 2-2m0-2a4 4 0 0 0-4 4c0 .5.1 1 .28 1.46l-.88 2.4A6.026 6.026 0 0 1 6 12a6 6 0 0 1 6-6a6 6 0 0 1 6 6c0 1.47-.53 2.81-1.4 3.86l-.88-2.4C15.9 13 16 12.5 16 12a4 4 0 0 0-4-4m0-4a8 8 0 0 0-8 8c0 2.36 1 4.5 2.64 5.94l-.72 2A10.005 10.005 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10c0 3.23-1.54 6.11-3.92 7.94l-.72-2C19 16.5 20 14.36 20 12a8 8 0 0 0-8-8z" />
                  </svg>
                  <svg class="svgYoutube" v-if="item.entrada == 'Y'" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="30px"
                    height="30px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                    <path
                      d="M10 15l5.19-3L10 9v6m11.56-7.83c.13.47.22 1.1.28 1.9c.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83c-.25.9-.83 1.48-1.73 1.73c-.47.13-1.33.22-2.65.28c-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44c-.9-.25-1.48-.83-1.73-1.73c-.13-.47-.22-1.1-.28-1.9c-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83c.25-.9.83-1.48 1.73-1.73c.47-.13 1.33-.22 2.65-.28c1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44c.9.25 1.48.83 1.73 1.73z" />
                  </svg>
                </div>
                <div class="col-auto">
                  <button class="button back-button tooltip" data-tooltip="Regresar" @click="goBack">
                    <svg width="10.975" height="9.998" viewBox="0 0 10.975 9.998">
                      <path id="Color_Overlay" data-name="Color Overlay"
                        d="M26.825,57.835l-3.549-4.046A.634.634,0,0,1,23,53.244v-.366a.7.7,0,0,1,.068-.308.641.641,0,0,1,.14-.282l3.615-4.122a.439.439,0,0,1,.706.028l.205.267a.706.706,0,0,1-.023.861L25.13,52.268h8.343a.564.564,0,0,1,.5.609v.366a.564.564,0,0,1-.5.609H25.236l2.478,2.825a.708.708,0,0,1,.023.861l-.205.266a.462.462,0,0,1-.365.194A.455.455,0,0,1,26.825,57.835Z"
                        transform="translate(-23 -48.001)" />
                    </svg>
                  </button>
                </div>
              </div>
              <!-- row align-items-center -->

              <div class="row align-items-center" v-if="snapshot != ''">
                <div class="col-12">
                  <div class="snapshot">
                    <img class="imgSnapshot center" :src="snapshot" />
                  </div>
                </div>
              </div>

              <div class="post-info" v-else>
                <div class="info-heading">
                  <div class="row align-items-center">
                    <div class="col">
                      <div class="input-field" v-if="editMode">
                        <br />
                        <input type="text" placeholder="Titulo de la nota" v-model="item.titulo" />
                      </div>
                      <h2 class="tiulo-post" v-html="convertString(item.titulo)" v-else></h2>
                      <!--<p class="blanco">Difundido el {{parseFecha(item.publicado_utc)}}</p>-->
                    </div>
                    <!-- col -->
                  </div>
                  <!-- row align-items-center -->
                </div>
                <!--info-heading-->
                <div class="content">
                  <div class="input-field description" v-if="editMode">
                    <ckeditor :editor="editor" v-model="item.nota" :config="editorConfig"></ckeditor>
                    <br /><br />
                  </div>
                  <p :key="contentKey" v-html="item.nota" v-else></p>
                  <textarea class="escondido" ref="copyText" v-model="getContent"></textarea>
                  <div class="row" v-if="(editMode == false && fi == 'T') || fi == 'R'">
                    <p class="col-12 touchpad link" @click="descargar">
                      Descargar
                    </p>
                    <p class="col-4 touchpad link" @click="openAbstract" v-if="bandIA">
                      Resumen
                    </p>
                    <p class="col-4 touchpad link" @click="openTranscription" v-if="bandIA">
                      Transcripción
                    </p>
                  </div>

                  <div class="row" v-if="fi == 'T' || fi == 'R'">
                    <p class="col-12 touchpad link" v-if="$store.state.userInfo.gridaccess" @click="goToNewsCast" :disabled="duracionVideoItem == 0">
                      Ir a Gridaccess
                    </p>
                    <p class="col-8 touchpad link" v-else :disabled="duracionVideoItem == 0">
                      Por el momento no cuentas con accesso a Gridaccess, por favor comunicate con tu Administrador.
                    </p>
                  </div>
                </div>
                <!-- content -->
              </div>
              <!--post-info-->

              <div class="row" style="
                        position: absolute;
                        bottom: 0;
                        right: 0;
                        padding-right: 15px;
                      ">
                <div class="button-container derecha" v-if="snapshot != ''">
                  <button class="button small accion-video tooltip tooltip-top blanco" data-tooltip="Cancelar Captura"
                    @click="cancelSnap()">
                    <font-awesome-icon icon="times" style="color: #ebf9ff; height: 15px" />
                  </button>
                  <button class="button small accion-video tooltip tooltip-top blanco" data-tooltip="Establecer Captura"
                    @click="saveSnap()">
                    <font-awesome-icon icon="check" style="color: #ebf9ff; height: 15px" />
                  </button>
                  <a :href="snapshot" download="captura.jpg"
                    class="button small accion-video tooltip tooltip-top blanco" data-tooltip="Descargar Captura">
                    <font-awesome-icon icon="download" style="color: #ebf9ff; height: 15px" />
                  </a>
                </div>
                <div class="button-container derecha" v-else>
                  <button class="button small accion-video tooltip tooltip-top blanco" data-tooltip="Guardar Edición"
                    @click="saveEdit()" v-if="editMode">
                    <font-awesome-icon icon="check" style="color: #ebf9ff; height: 15px" />
                  </button>
                  <button class="button small accion-video tooltip tooltip-top blanco" data-tooltip="Cancelar Edición"
                    @click="cancelEdit()" v-if="editMode">
                    <font-awesome-icon icon="times" style="color: #ebf9ff; height: 15px" />
                  </button>

                  <button class="button small star-video tooltip tooltip-top blanco" data-tooltip="Reestablecer Nota"
                    v-if="item.metadatos" @click="redo">
                    <font-awesome-icon icon="redo-alt" style="color: #ebf9ff; height: 15px" />
                  </button>

                  <button class="button small star-video tooltip tooltip-top blanco" data-tooltip="Copiar Nota"
                    @click="copy" v-if="editMode == false">
                    <font-awesome-icon icon="copy" style="color: #ebf9ff; height: 15px" />
                  </button>

                  <button class="button small accion-video tooltip tooltip-top" data-tooltip="Cambiar Imagen de video"
                    @click="changeImage()" v-if="item.entrada == 'T' || item.entrada == 'R'">
                    <font-awesome-icon icon="photo-video" style="color: #ebf9ff; height: 15px" />
                    <input type="file" style="display: none" ref="posterVideo" accept="image/*"
                      @change="onFilePicked" />
                    <!--<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-camera"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle></svg>>-->
                  </button>
                  <button class="button small star-video tooltip tooltip-top blanco" data-tooltip="Editar"
                    @click="editNote()" v-if="editMode == false">
                    <font-awesome-icon icon="edit" style="color: #ebf9ff; height: 15px" />
                  </button>
                  <button class="button small accion-video tooltip tooltip-top blanco" data-tooltip="Agregar a carpeta"
                    @click="saveNote" v-if="editMode == false">
                    <font-awesome-icon icon="folder-plus" style="color: #ebf9ff; height: 15px" />
                  </button>
                  <button class="button small accion-video tooltip tooltip-top blanco" data-tooltip="Descargar"
                    @click="descargar" v-if="(editMode == false && fi == 'T') || fi == 'R'">
                    <font-awesome-icon icon="cloud-download-alt" style="color: #ebf9ff; height: 15px" />
                  </button>
                  <!--<button class="button small accion-video tooltip tooltip-top  blanco " data-tooltip="Enviar"  @click="enviar" v-if="editMode==false">
                        <font-awesome-icon  icon="paper-plane" style="color:#ebf9ff; height:15px"/>
                      </button>-->
                  <button class="button small accion-video tooltip tooltip-top blanco" data-tooltip="Compartir"
                    @click="compartir">
                    <font-awesome-icon icon="share-alt" style="color: #ebf9ff; height: 15px" />
                  </button>
                  <button class="button small accion-video tooltip tooltip-top blanco"
                    data-tooltip="Añadir a newsletter" @click="agregar_note_newsletter" v-if="permissionsNewsletter">
                    <font-awesome-icon icon="folder-plus" style="color: #ebf9ff; height: 15px" />
                  </button>
                </div>
              </div>
              <!-- row actions align-items-center -->
            </div>
            <!-- col-sm-12 col-md-7-->
          </div>
          <!-- row -->
          <br />
          <div class="divider"></div>
          <div class="comentarios">
            <h2>Comentarios</h2>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div class="row">
                  <div class="col-12">
                    <label class="form-text">Escriba un comentario</label>
                    <button class="button small accion-video tooltip tooltip-top derecha verde-claro"
                      data-tooltip="Comentar" @click="addComment" v-if="comment.trim() != ''">
                      <font-awesome-icon icon="check" style="color: #ebf9ff; height: 15px" />
                    </button>
                    <button class="button small accion-video tooltip tooltip-top derecha verde-claro"
                      data-tooltip="Borrar" @click="cleanComment" v-if="comment.trim() != ''">
                      <font-awesome-icon icon="trash-alt" style="color: #ebf9ff; height: 15px" />
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <ckeditor @click="setComment" :editor="editor" v-model="comment" :config="editorConfig"></ckeditor>
                  </div>
                </div>
              </div>

              <div class="col-sm-12 col-md-6 boxComments" v-if="comments.length > 0">
                <div class="noMargin" style="
                          width: 100%;
                          border-bottom: 1px solid #24404b;
                          padding-bottom: 1%;
                        " v-for="(comment, index) in comments" :key="comment.key">
                  <div class="inlineBlock noPadding noMargin" style="width: 95%">
                    <div v-html="convertString(comment.comentario)"></div>
                    <label class="sub">{{ getFecha(comment.created) }}</label>
                  </div>

                  <div class="inlineBlock" style="width: 5%; float: right; top: 0">
                    <button class="button small accion-video tooltip tooltip-bottom derecha verde-claro"
                      data-tooltip="Borrar" @click="eliminaComentario(comment.key, index)">
                      <font-awesome-icon icon="trash-alt" style="color: #ebf9ff; height: 15px" />
                    </button>
                    <!--<font-awesome-icon  icon="trash-alt"  style="color:#ebf9ff; height:15px;cursor:pointer"/>-->
                    <!--<close-icon class="icon_close touchpad derecha" @click="eliminaComentario(comment.key,index)"></close-icon>-->
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6"></div>
              <div class="col-sm-12 col-md-6">
                <div class="button-circle-more secondary" v-if="LastEvaluatedKey">
                  <button class="circle-more" @click="getComments">
                    <svg viewBox="0 0 18 18">
                      <g id="Grupo_29" data-name="Grupo 29" transform="translate(-171 -753)">
                        <rect id="Rectángulo_redondeado_903" data-name="Rectángulo redondeado 903" width="2" height="18"
                          rx="1" transform="translate(179 753)" fill="#fff" />
                        <rect id="Rectángulo_redondeado_903_copia" data-name="Rectángulo redondeado 903 copia"
                          width="18" height="2" rx="1" transform="translate(171 761)" fill="#fff" />
                      </g>
                    </svg>
                  </button>
                </div>
                <!-- END BUTTON CIRCLE -->
              </div>
            </div>
          </div>
          <!-- comments -->

          <!--<div class="page-actions"> <button class="button small outline" @click="goBack">Regresar</button></div>-->
        </div>
        <!-- div w80-->
      </div>
    </section>
    <confirm-modal :smsModal="smsModal" :show="showModal" @cancelar="hideModal" @aceptar="elimina"></confirm-modal>
    <confirm-modal-comment :smsModal="smsModal" :show="showModal" @cancelar="hideModal"
      @aceptar="deleteComment"></confirm-modal-comment>
    <!--modal download de datos-->
    <div :class="['modal-container', { active: isActive }]">
      <!--agregar clas "active" para mostrarlo  <div class="modal-container active">-->
      <div class="card head-card news oDatosCard">
        <div class="title-card">
          <h4>Guardar como...</h4>
          <button class="touchpad" @click="
            () => {
              closeModal();
            }
          ">
            x
          </button>
        </div>
        <div class="card-content">
          <div class="item">
            <div class="card secondary">
              <p class="paragraph dark">Escriba el nombre del archivo</p>
              <input type="text" class="fName" placeholder="Nombre del archivo" v-model="nombre_download" />
            </div>
          </div>

          <button class="button alternative fluid" @click="
            () => {
              download();
            }
          ">
            {{ labelDescargar }}
          </button>
        </div>
      </div>
    </div>

    <!--modal RESUMEN de datos-->
    <div :class="['modal-container', { active: isAbstract }]">
      <!--agregar clas "active" para mostrarlo  <div class="modal-container active">-->
      <div class="card head-card news" style="max-width: 40%; height: 60%">
        <div class="title-card">
          <h4>Resumen</h4>
          <button class="touchpad" @click="closeModalRe">
            x
          </button>
        </div>
        <div class="card-content">
          <div class="item">
            <div class="card secondary">
              <p class="paragraph dark" id="textoACopiarResumen">
                {{ abstractTxt }}
              </p>
            </div>
          </div>
          <div class="Keywords-button-container">
            <button style="background-color: #00b99e;" class=" button   tooltip tooltip-top" data-tooltip="Copiar texto"
              @click="
                () => {
                  copiar('textoACopiarResumen');
                }
              ">
              <font-awesome-icon icon="copy" style="color: #ebf9ff; height: 15px" />
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- div modal exportfile-->
    <!--modal TRANSCRIPCION de datos-->
    <div :class="['modal-container', { active: isTranscription }]">
      <!--agregar clas "active" para mostrarlo  <div class="modal-container active">-->
      <div class="card head-card news" style="max-width: 40%; height: 60%">
        <div class="title-card">
          <h4>Transcripción</h4>
          <button class="touchpad" @click="
            () => {
              closeModalTr();
            }
          ">
            x
          </button>
        </div>
        <div class="card-content trascripcion">
          <div class="item">
            <div class="card secondary">
              <p class="paragraph dark" id="textoACopiartras" ref="transcripcion">
                {{ trascriptionTxt }}
              </p>
            </div>
          </div>
          <div class="Keywords-button-container">
            <button style="background-color: #00b99e;" class=" button   tooltip tooltip-top" data-tooltip="Copiar texto"
              @click="
                () => {
                  copiar('textoACopiartras');
                }
              ">
              <font-awesome-icon icon="copy" style="color: #ebf9ff; height: 15px" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- div modal exportfile-->
    <share-box :show="shareAlt" @share="share" @cancelar="cancelarShare"></share-box>
  </div>
</template>

<script>
import SideMenu from "@/components/sideMenu";
import mnavbar from "@/components/mnavbar";
import mvideo from "@/components/mvideo";

import emailAlert from "@/components/emailAlert";
import { strings } from "@/services/strings.js";

require("videojs-contrib-hls/dist/videojs-contrib-hls");

import videojs from "video.js";
window.videojs = videojs;

import confirmModal from "@/components/confirm";
import confirmModalComment from "@/components/confirm";
import shareBox from "@/components/shareBox";

import moment from "moment-timezone";

import closeIcon from "vue-material-design-icons/Close.vue";
import _ from "lodash";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCloudDownloadAlt,
  faPaperPlane,
  faSave,
  faChevronDown,
  faFolderPlus,
  faComment,
  faTimes,
  faEdit,
  faCheck,
  faPhotoVideo,
  faCamera,
  faShareAlt,
  faCopy,
  faDownload,
  faRedoAlt,
} from "@fortawesome/free-solid-svg-icons";
library.add(faCloudDownloadAlt);
library.add(faPaperPlane);
library.add(faSave);
library.add(faChevronDown);
library.add(faFolderPlus);
library.add(faComment);
library.add(faTimes);
library.add(faEdit);
library.add(faCheck);
library.add(faPhotoVideo);
library.add(faCamera);
library.add(faShareAlt);
library.add(faCopy);
library.add(faDownload);
library.add(faRedoAlt);

import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

require("videojs-youtube/dist/Youtube");

import Vue from "vue";
import VueCryptojs from "vue-cryptojs";
import { decode } from "punycode";
Vue.use(VueCryptojs);
export default {
  props: ["fi", "id", "on"],
  components: {
    SideMenu,
    mnavbar,
    mvideo,
    confirmModal,
    closeIcon,
    emailAlert,
    confirmModalComment,
    shareBox,
  },
  mixins: [strings],
  data() {
    return {
      isLoading: false,
      menuOn: false,
      fuente_info: null,
      urlGridaccess: this.$store.getters.getMainUrlGridaccess,
      url: this.$store.getters.getMainUrl,
      player: null,
      playerOptions: {
        // videojs and plugin options
        width: "350px",
        height: "100%",
        sources: [
          {
            withCredentials: false,
            type: "application/x-mpegURL",
            src: "",
          },
        ],
        controlBar: {
          timeDivider: false,
          durationDisplay: true,
        },
        flash: { hls: { withCredentials: false } },
        html5: { vhs: { withCredentials: false, overrideNative: true },
                  hls: { withCredentials: false, overrideNative: true },
                  nativeAudioTracks: false,
                  nativeVideoTracks: false },
        poster: this.$store.state.defaultNote,
        autoplay: true,
        responsive: true,
      },
      item: {},
      showModal: false,
      smsModal: "Realmente, ¿Desea eliminar ésta nota de la carpeta?",
      stars: [
        "button small star-video tooltip tooltip-bottom",
        "button small star-video tooltip tooltip-bottom",
        "button small star-video tooltip tooltip-bottom",
        "button small star-video tooltip tooltip-bottom",
      ],
      noStars: 0,
      like: false,
      dislike: false,
      meh: false,
      comments: [],
      emailModal: false,
      thumb: "",
      activeVideo: false,
      from: "",
      fromParams: {},
      extraParams: {},
      media: "",
      defaultImage: this.$store.state.defaultTV,
      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        toolbar: {
          items: ["bold", "italic"],
        },
      },
      comment: "",
      commentKey: null,
      commentIndex: -1,
      showComment: false,
      editMode: false,
      originalItem: {},
      LastEvaluatedKey: null,
      posterVideo: "",
      snapshot: "",
      playing: false,
      markI: 0,
      markF: 0,
      changeOrigen: false,
      //download
      isActive: false,
      nombre_download: "",
      tooltip: false,
      //compartir
      shareAlt: false,
      urlShare: "",
      contentKey: new Date().getTime(),
      dur: 0,
      permissionsNewsletter: false,
      duracionVideoItem: 0,
      bandIA: false,
      isAbstract: false,
      isTranscription: false,
      abstractTxt: "",
      trascriptionTxt: "",
      labelDescargar: "Descargar",
    };
  },
  computed: {
    token() {
      return this.$store.getters.getToken;
    },
    getContent() {
      if (this.item.titulo) {
        var fecha = this.parseFecha(this.item.publicado_utc);
        var arrFecha = fecha.split(" ");

        var titulo = this.item.titulo ? this.item.titulo.trim() : "";
        var descripcion = "";
        if (this.item.entrada == "R" || this.item.entrada == "T") {
          var conductor = this.item.descripcion.conductor
            ? this.item.descripcion.conductor
            : "";
          var programa = this.item.descripcion.programa
            ? this.item.descripcion.programa
            : "";
          var inicio = this.item.descripcion.inicio
            ? this.item.descripcion.inicio
            : "";
          var dur = this.item.descripcion.duracion
            ? this.item.descripcion.duracion
            : "";
          //descripcion = 'Medio: ' + this.media + '\n';
          //descripcion = 'Conductor: ' + conductor + '\n';
          //descripcion = 'Difundido el' + this.parseFecha(this.item.publicado_utc) + '\n';

          descripcion += "Hora de Inicio: " + inicio + "\n";
          descripcion += "Duración: " + dur + "\n\n";
          descripcion +=
            "Liga de reproducción  y descarga: " + "\n" + this.urlShare;
        } else {
          var desc = this.item.descripcion
            ? this.item.descripcion.replace(/<(?:.|\n)*?>/gm, "")
            : "";

          titulo = titulo == "" ? desc.substring(0, 10) + "..." : titulo;

          descripcion += "Hora: " + arrFecha[1] + "\n";
          descripcion += "Liga de reproducción  " + "\n" + this.urlShare;
        }

        var text =
          titulo.trim() +
          `\n` +
          `Nota de ` +
          this.media +
          `\n` +
          `Canal: ` +
          this.item.nombre_canal +
          `\n` +
          `Noticiero: ` +
          this.item.noticiero.nombre +
          `\n` +
          `Fecha: ` +
          arrFecha[0] +
          `\n` +
          descripcion;

        return text;
      }
    },
  },

  async beforeMount() {
    console.log("beforeMount nota video");

    var backData2 = this.$store.state.backData2;
    var d = backData2.length > 0 ? backData2[backData2.length - 1] : {};
    this.from = d.from;
    this.fromParams = d.fromParams;
    this.extraParams = d.extraParams;
  },
  mounted() {
    this.load();
    this.getPermisoNesletter();
  },
  watch: {
    posterVideo() {
      this.thumb = this.playerOptions.poster = this.posterVideo;
      this.changeThumb();
    },
  },
  methods: {
    calcular_timpo_recorte() {
      var time = `00:00:00`;
      var fechaTime = new Date("1970-01-01T" + time);
      fechaTime.setSeconds(fechaTime.getSeconds() + this.markF);
      fechaTime.setSeconds(fechaTime.getSeconds() - this.markI);
      return fechaTime.toLocaleTimeString();
    },
    mostrar_minutos(segundos) {
      var time = `00:00:00`;
      var fechaTime = new Date("1970-01-01T" + time);
      fechaTime.setSeconds(fechaTime.getSeconds() + segundos);
      var nTime = fechaTime.toLocaleTimeString();
      const tiempoArray = nTime.split(":");
      console.log(nTime, "nuevo tiempo===>");

      return `${tiempoArray[0]}:${tiempoArray[1]}:${tiempoArray[2]}`;
    },
    armarFecha(fecha) {
      // var f = fecha.split(':')[0];
      // console.log(f);
      // f = f.split('T')[0]
      // f = f.split('-');
      var fFinal = this.item.claveorigen.split("-")[2];
      // console.log(fFinal);

      return fFinal;
    },
    async goToNewsCast1() {
      var sc = this.changeOrigen
        ? this.item.metadatos.claveorigen.split("-")
        : this.item.claveorigen.split("-");
      var diA = this.armarFecha(this.item.fecha);
      var ini = Math.floor(sc[4]);
      // var restaPorMed = this.item.entrada == "T"? 5.8: 3.8;
      // var restaPorMedD = this.item.entrada == "T"? 20: 30;
      var inicio = await this.obtenerTiempoEnSegundos(parseInt(ini) - 10); //-3.8
      //console.log("##############");
      //console.log(inicio);
      //console.log(this.changeOrigen, "changeOrigen", sc[5]);
      var to = sc[5].split("&");
      //console.log(to[0])
      var t = this.changeOrigen ? Math.floor(to[0]) : sc[5]; //-37

      var duracion = await this.duracionOptener(t);

      const url = `https://live.bdtr.net/Gridaccess/index.php`;
      // const url = `http://d2.bdtr.net/Gridaccess/index.php`
      var nombreN = this.item.nombre_canal
        ? this.item.nombre_canal
        : this.item.noticiero.nombre;

      var canalTip =
        this.item.medioTipo == "r"
          ? this.item.noticiero.canal
          : `${this.item.noticiero.canal}HI`;

      const postData = [
        { key: "city", value: this.item.noticiero.ciudad },
        { key: "canal", value: canalTip },
        { key: "date", value: `${diA}` },
        { key: "ini", value: inicio },
        { key: "station", value: nombreN },
        { key: "dur", value: duracion },
        { key: "key", value: "3DEFRT43E" },
      ];

      //console.log(postData, "datos para el post gridAccess");

      this.goToGrid(url, postData);
    },
    async goToNewsCast() {
      console.log(this.item);
      var sc = this.changeOrigen
        ? this.item.metadatos.claveorigen.split("-")
        : this.item.claveorigen.split("-");
      var diA = this.armarFecha(this.item.fecha);
      var ini = Math.floor(sc[4]);
      // var restaPorMed = this.item.entrada == "T"? 5.8: 3.8;
      // var restaPorMedD = this.item.entrada == "T"? 20: 30;
      var inicio = await this.obtenerTiempoEnSegundos(parseInt(ini) - 10); //-3.8

      console.log(this.changeOrigen, "changeOrigen", sc[5]);
      var to = sc[5].split("&");
      console.log(to[0]);
      var t = this.changeOrigen ? Math.floor(to[0]) : sc[5]; //-37

      var duracion = await this.duracionOptener(t);

      const url = `https://live.bdtr.net/Gridaccess/index.php`;
      // const url = `http://d2.bdtr.net/Gridaccess/index.php`
      var nombreN = this.item.nombre_canal
        ? this.item.nombre_canal
        : this.item.noticiero.nombre;

      var canalTip =
        this.item.medioTipo == "r"
          ? this.item.noticiero.canal
          : `${this.item.noticiero.canal}HI`;

      const postData = [
        { key: "city", value: this.item.noticiero.ciudad },
        { key: "canal", value: canalTip },
        { key: "date", value: `${diA}` },
        { key: "ini", value: inicio },
        { key: "station", value: nombreN },
        { key: "dur", value: duracion },
        { key: "key", value: "3DEFRT43E" },
      ];
      ///////////////////////////////////////////////////
      let json = {
        city: this.item.noticiero.ciudad,
        nameChannel: this.item.nombre_canal,
        channel: canalTip,
        date: diA,
        time: inicio,
        dur: duracion,
        key: "3DEFRT43E",
        medio: this.item.medioTipo,
       // token: this.$store.getters.getToken,
      };
      console.log(postData, "datos para el post gridAccess");

      const queryString = new URLSearchParams(json).toString();
     
      window.open(this.urlGridaccess + queryString, "_blank");
      //////////////////////////////////////////
    },
    goToGrid(url, postData) {
      const form = document.createElement("form");
      form.setAttribute("method", "POST");
      form.setAttribute("action", url);
      form.setAttribute("target", "_blank");
      document.body.appendChild(form);

      for (var a in postData) {
        const input1 = document.createElement("input");
        input1.setAttribute("type", "hidden");
        input1.setAttribute("name", postData[a].key);
        input1.setAttribute("value", postData[a].value);
        form.appendChild(input1);
      }
      console.log(form);

      const iframe = document.createElement("iframe");
      iframe.setAttribute("name", "my-iframe");
      iframe.setAttribute("style", "display: none");
      document.body.appendChild(iframe);

      form.submit();
    },
    async obtenerTiempoEnSegundos(time) {
      console.log(time);
      var fechaTime = new Date("1970-01-01T00:00:00");
      fechaTime.setSeconds(fechaTime.getSeconds() + time);
      fechaTime.setMinutes(fechaTime.getMinutes() - 1);
      fechaTime.setSeconds(fechaTime.getSeconds() - 5);

      console.log(fechaTime.toLocaleTimeString());
      var listSeconds = fechaTime
        .toLocaleTimeString("en-GB", { hour12: false })
        .split(":");
      var nTime = "";
      listSeconds.forEach((element) => {
        var t = parseInt(element, 10);
        if (t < 10) {
          t = "0" + t;
        }
        nTime = nTime + t;
      });

      return nTime;
    },
    /*async obtenerTiempoEnSegundos(time) {
      console.log(time);
      var timew = `00:00:00`;
      var fechaTime = new Date('1970-01-01T' + timew);
      fechaTime.setSeconds(fechaTime.getSeconds() + time);
      fechaTime.setMinutes(fechaTime.getMinutes() - 1);
      fechaTime.setSeconds(fechaTime.getSeconds() - 5);
      console.log(fechaTime.toLocaleTimeString());
      var listSeconds = fechaTime.toLocaleTimeString().split(":");
      var nTime = "";
      listSeconds.forEach(element => {
        var t = Math.floor(element);
        if (t < 10) {
          t = '0' + t;
        }
        nTime = nTime + t;
      });

      return nTime;

    },*/

    obtenerTiempoEnSegundos2(time) {
      console.log("tiempo en segundo =->", time);
      // Sumamos 30 segundos extra
      time -= 30;
      console.log("tiempo en segundo agregados =->", time);
      var fechaTime = new Date("1970-01-01T00:00:00");
      fechaTime.setSeconds(fechaTime.getSeconds() + time);
      fechaTime.setMinutes(fechaTime.getMinutes());
      fechaTime.setSeconds(fechaTime.getSeconds());

      console.log(fechaTime.toLocaleTimeString());
      var listSeconds = fechaTime
        .toLocaleTimeString("en-GB", { hour12: false })
        .split(":");
      var nTime = "";
      listSeconds.forEach((element) => {
        var t = parseInt(element, 10);
        if (t < 10) {
          t = "0" + t;
        }
        nTime = nTime + t;
      });

      return nTime;
    },
    /*  obtenerTiempoEnSegundos2(time) {
      var fechaTime = new Date('1970-01-01T00:00:00');
      fechaTime.setSeconds(fechaTime.getSeconds() + time);

      var listSeconds = fechaTime.toLocaleTimeString('en-GB', { hour12: false }).split(":");
      var nTime = "";
      listSeconds.forEach(element => {
        var t = parseInt(element, 10);
      
        if (t < 10) {
          t = '0' + t;
        }
        nTime = nTime + t;
      });

      return nTime;
    },*/
    /*
 obtenerTiempoEnSegundos2(time) {
      var timew = `00:00:00`;
      var fechaTime = new Date('1970-01-01T' + timew);
      fechaTime.setSeconds(fechaTime.getSeconds() + time);

      // fechaTime.setSeconds(fechaTime.getSeconds() - 10);
      console.log(fechaTime.toLocaleTimeString());
      var listSeconds = fechaTime.toLocaleTimeString().split(":");
      console.log(listSeconds);
      var nTime = "";
      listSeconds.forEach(element => {
        var t = Math.floor(element);
        console.log(t);
        if (t < 10) {
          t = '0' + t;
        }
        nTime = nTime + t;
      });

      return nTime;

    },*/

    async duracionRecorte(inicio) {
      var nTime = inicio;
      var fechaTime = new Date("1970-01-01T" + nTime);
      console.log(
        this.markI,
        "==>",
        fechaTime.toLocaleTimeString(),
        "==>",
        inicio
      );
      fechaTime.setSeconds(fechaTime.getSeconds() + this.markI);
      console.log(
        this.markI,
        "==>",
        fechaTime.toLocaleTimeString(),
        "==>",
        inicio
      );
      var total = this.obtenerTiempoEnSegundos(fechaTime.toLocaleTimeString());

      return total;
    },
    async duracionOptener(time) {
      console.log("duracion clave", time);
      var second = Math.floor(time);
      return second + 100;
    },
    load() {
      //funcion inicial
      //this.isLoading = true;
      this.fuente_info = this.fi;
      if (this.fuente_info != null) {
        this.getNote();
        this.getComments();
      } else {
        this.isLoading = false;
        //redirigir pantalla not found
        this.error("error, url no válida");
      }
    },
    getNote() {
      // console.log("getNote");
      var post_data = {
        token: this.token,
        key: this.id,
        entrada: this.fuente_info, // TW, I,T,R,Y
        logs: true,
      };
      // console.log(post_data);
      var self = this;
      axios
        .post(this.url + "getNote", JSON.stringify(post_data))
        .then((response) => {
          self.isLoading = false;
          if (response.data.success) {
            self.setItem(response.data.data);
          } else {
            self.error(response.data.error);
          }
        })
        .catch(function (error) {
          self.isLoading = false;
          self.error(error);
        });
    },
    getComments() {
      //console.log("getComments");
      var post_data = {
        token: this.token,
        key: this.id,
        limit: 5,
        feed: this.fi, // TW, I,T,R,Y
      };
      var self = this;
      if (this.LastEvaluatedKey)
        post_data["LastEvaluatedKey"] = this.LastEvaluatedKey;
      axios.post(this.url + "listComments", post_data).then((response) => {
        if (self.comments.length == 0) {
          self.comments = response.data.result;
          self.total = response.data.total;
        } else {
          self.comments = [].concat(self.comments, response.data.result);
          self.total = self.total + response.data.total;
        }
        self.LastEvaluatedKey = response.data.LastEvaluatedKey
          ? response.data.LastEvaluatedKey
          : null;
      });
    },
    editNote() {
      this.originalItem = Object.assign(this.originalItem, this.item);
      this.editMode = true;
      /*this.isLoading=true;
      this.$router.push({
        name: "notaVideoEdit",
        params: {
          id: this.id,
          fi: this.fi
        }
      });*/
    },
    cancelEdit() {
      this.item = Object.assign(this.item, this.originalItem);
      this.editMode = false;
    },
    async saveEdit() {
      this.isLoading = true;

      var post_data = {
        token: this.token,
        data: {
          cmd: "editNote",
          fi: this.fi, //"FB"
          key: this.id, //"NoticierosTelevisacom-1007337109658149"
          titulo: this.item.titulo,
          descripcion: this.item.nota,
        },
      };

      var r = await this.editaNota(post_data);
      // console.log(r);
      this.editMode = false;
      this.isLoading = false;
      if (r.success) {
        this.success("Edicion Completa");
        self.reload();
      } else {
        this.error(r.error);
      }
    },
    editaNota(post_data) {
      var self = this;
      return new Promise((resolve, reject) => {
        axios
          .post(this.url + "metadatos", post_data)
          .then((response) => {
            resolve(response.data);
          })
          .catch(function (error) {
            resolve({ success: false, error: error });
          });
      });
    },
    async setItem(data) {
      this.item = data;
      this.bandIA = this.item.notaIA ? true : false;
      var fecha = this.parseFecha(this.item.publicado_utc);
      var fecha_arr = fecha.split(" ");
      var publicado = this.item.publicado
        ? this.item.publicado.split(" ")
        : fecha_arr;
      // console.log("item", this.item);
      var hora = this.item.descripcion
        ? this.item.descripcion.inicio
        : publicado[1];
      switch (this.fuente_info) {
        case "T":
          this.media = "Televisión";
          //this.item.claveorigen = "DF_MEX-T20-20200317-131908-67174-10&cut=1";
          this.playerOptions.sources[0].src = this.getVideoUrlVideo();
          this.thumb = this.playerOptions.poster = this.item.thumb
            ? this.item.thumb
            : this.item.noticiero.imagen;

          var conductor = this.item.descripcion.conductor
            ? this.item.descripcion.conductor
            : "";
          var programa = this.item.descripcion.programa
            ? this.item.descripcion.programa
            : "";
          var inicio = this.item.descripcion.inicio
            ? this.item.descripcion.inicio
            : "";
          var dur = this.item.descripcion.duracion
            ? this.item.descripcion.duracion
            : "";
          var genero = this.item.genero ? this.item.genero : ""; //EGM 130223
          //this.item.titulo = this.convertString(this.item.titulo);
          //this.item.nota = '<p>Programa: <strong>' + programa + '</strong><br>';
          this.item.nota = "<p>Medio: <strong>" + this.media + "</strong><br>";
          if (this.item.grupo) {
            this.item.nota +=
              "Grupo periodistico: <strong>" +
              this.item.grupo +
              "</strong><br>";
          }
          // this.item.nota = "<p>Grupo periodistico: <strong>" + 'grupo' + "</strong><br>";
          this.item.nota += "Conductor: <strong>" + conductor + "</strong><br>";

          this.item.nota +=
            genero != "" ? "Género: <strong>" + genero + "</strong><br>" : ""; //EGM 130223

          this.item.nota += "Fecha: <strong>" + fecha_arr[0] + "</strong><br>";
          this.item.nota += "Hora de Inicio: <strong>" + hora + "</strong><br>";

          //this.item.nota += 'Inicio: <strong>' + inicio + '</strong><br>';
          this.item.nota += "Duración: <strong>" + dur + "</strong>";
          if (this.item.region) {
            this.item.nota +=
              "<br>Región: <strong>" + this.item.region + "</strong>";
          }
          this.item.nota += "</p>";

          this.$nextTick(function () {
            this.$set(this.item, "nota", this.item.nota);
          });
          break;
        case "R":
          this.media = "Radio";
          //this.item.titulo = this.convertString(this.item.titulo);
          this.playerOptions.sources[0].src = this.getVideoUrlVideo();
          this.defaultImage = this.$store.state.defaultRadio;
          this.thumb = this.playerOptions.poster = this.item.thumb
            ? this.item.thumb
            : this.item.noticiero.imagen;

          var conductor = this.item.descripcion.conductor
            ? this.item.descripcion.conductor
            : "";
          var programa = this.item.descripcion.programa
            ? this.item.descripcion.programa
            : "";
          var inicio = this.item.descripcion.inicio
            ? this.item.descripcion.inicio
            : "";
          var dur = this.item.descripcion.duracion
            ? this.item.descripcion.duracion
            : "";
          var genero = this.item.genero ? this.item.genero : ""; //EGM 130223

          //this.item.nota = '<p>Programa: <strong>' + programa + '</strong><br>';
          this.item.nota = "<p>Medio: <strong>" + this.media + "</strong><br>";
          if (this.item.grupo) {
            this.item.nota +=
              "Grupo periodistico: <strong>" +
              this.item.grupo +
              "</strong><br>";
          }

          this.item.nota += "Conductor: <strong>" + conductor + "</strong><br>";
          this.item.nota += "Género: <strong>" + genero + "</strong><br>"; //EGM 130223
          this.item.nota += "Fecha: <strong>" + fecha_arr[0] + "</strong><br>";
          this.item.nota += "Hora de Inicio: <strong>" + hora + "</strong><br>";
          //this.item.nota += 'Inicio: <strong>' + inicio + '</strong><br>';
          this.item.nota += "Duración: <strong>" + dur + "</strong>";
          if (this.item.region) {
            this.item.nota +=
              "<br>Región: <strong>" + this.item.region + "</strong>";
          }
          this.item.nota += "</p>";
          this.$nextTick(function () {
            this.$set(this.item, "nota", this.item.nota);
          });
          break;
        case "Y":
          this.media = "Youtube";
          this.item.descripcion = this.item.descripcion
            ? this.item.descripcion
            : "";
          var nota = this.item.descripcion.replace(/(?:\r\n|\r|\n)/g, "<br />");
          var parser = new DOMParser();
          var dom = parser.parseFromString(
            "<!doctype html><body>" + nota,
            "text/html"
          );

          var decodedString = dom.body.innerHTML;
          // console.log("decoded String", decodedString);
          if (this.item.grupo) {
            this.item.nota +=
              "Grupo periodistico: <strong>" +
              this.item.grupo +
              "</strong><br>";
          }
          this.item.nota = "Fecha: <strong>" + fecha_arr[0] + "</strong><br>";
          this.item.nota += "Hora: <strong>" + hora + "</strong><br><br>";
          if (this.item.region) {
            this.item.nota +=
              "<br>Región: <strong>" + this.item.region + "</strong>";
          }
          this.item.nota += "</p>";

          if (decodedString != this.item.titulo)
            this.item.nota += decodedString;

          var id_arr = this.item.media.split("?");

          var id_arr2 = id_arr[1].split("=");
          var id = id_arr2[1];
          this.thumb = "https://img.youtube.com/vi/" + id + "/default.jpg";
          this.defaultImage = this.$store.state.defaultYoutube;

          this.item.noticiero = {
            nombre: this.item.noticiero_nombre,
            imagen: this.item.noticiero_img,
          };

          this.playerOptions = {
            height: "100%",
            sources: [
              {
                type: "video/youtube",
                src: this.item.media,
              },
            ],
            techOrder: ["youtube", "html5"],
            autoplay: true,
            responsive: true,
          };
          break;
      }

      var note_params = {
        table: this.getTable(this.item.entrada),
        key: this.item.key,
        token: this.token,
      };

      this.urlShare = await this.getEncryptedUrl(note_params);

      if (this.item.metadatos) {
        var new_item = this.item.metadatos;

        if (new_item.titulo) {
          this.$nextTick(function () {
            this.$set(this.item, "titulo", new_item.titulo);
          });
        }

        if (new_item.descripcion) {
          // console.log("hay descripcion en metadatos");
          this.$nextTick(function () {
            if (this.item.entrada == "Y") {
              var desc = new_item.descripcion.replace(
                /(?:\r\n|\r|\n)/g,
                "<br />"
              );
              var parser = new DOMParser();
              var dom = parser.parseFromString(
                "<!doctype html><body>" + desc,
                "text/html"
              );

              var decodedString = dom.body.innerHTML;
              // console.log(decodedString);

              this.$set(this.item, "nota", decodedString);
              this.contentKey = new Date().getTime();
            } else {
              this.$set(this.item, "nota", new_item.descripcion);
            }
          });
        }

        if (new_item.claveorigen) {
          this.changeOrigen = true;
          var clv = new_item.claveorigen.split("&");
          this.playerOptions.sources[0].src = this.getVideoUrlVideo(); //aqui modifique
        }

        this.thumb = this.playerOptions.poster = new_item.imagen
          ? new_item.imagen
          : this.thumb;
        //this.item.claveorigen = new_item.claveorigen? this.$store.getters.getVideoUrl + new_item.claveorigen : this.item.claveorigen;
        this.noStars = new_item.stars ? new_item.stars : this.noStars;
        this.setLikes(new_item.lke);

        this.setStars(this.noStars);
      }
      this.contentKey = new Date().getTime();
      // console.log(this.contentKey);
    },
    saveNote() {
      var p = { from: "notaVideo", fromParams: { id: this.id, fi: this.fi } };
      this.$store.commit("saveBack2", p);

      this.$router.push({
        name: "guardarEnCarpeta",
        params: {
          keyNote: { id: this.id, fi: this.fi },
        },
      });
    },
    // -----  eliminar nota de carpeta ------
    deleteNote() {
      this.showModal = true;
    },
    hideModal() {
      this.showModal = false;
    },
    elimina() {
      this.showModal = false;
      var folderKey = this.fromParams.id.toString();

      var post_data = {
        token: this.token,
        folderKey: folderKey,
        itemKey: this.extraParams.key,
      };
      var self = this;
      axios
        .post(self.url + "deleteItemFromFolder", JSON.stringify(post_data))
        .then((response) => {
          self.isLoading = false;
          // console.log(response.data);
          if (response.data.success) {
            self.$snotify.success(
              "Eliminado Correctamente de Carpeta",
              "Success"
            );
            //var routeBack = self.from == 'folder'
            self.goBack();
          } else {
            self.$snotify.error(response.data.error, "Error");
          }
        })
        .catch(function (error) {
          self.isLoading = false;
          var response = { success: false, error: error };
          // console.log(error);
        });
    },
    async saveLike(type) {
      var post_data = {
        token: this.token,
        providerID: this.providerID,
        data: {
          cmd: "editNote",
          fi: this.fi, //"FB"
          key: this.id, //"NoticierosTelevisacom-1007337109658149"
          like: type,
        },
      };
      var r = await this.editaNota(post_data);
      // console.log(r);
      if (r.success) {
        this.setLikes(type);

        //this.success('Edicion Completa');
      } else {
        this.error(r.error);
      }
    },
    async saveStars(noStars) {
      var post_data = {
        token: this.token,
        providerID: this.providerID,
        data: {
          cmd: "editNote",
          fi: this.fi, //"FB"
          key: this.id, //"NoticierosTelevisacom-1007337109658149"
          stars: noStars,
        },
      };
      var r = await this.editaNota(post_data);
      // console.log(r);
      if (r.success) {
        this.setStars(noStars);
      } else {
        this.error(r.error);
      }
    },
    setStars(noStars) {
      this.noStars = noStars == undefined ? this.noStars : noStars;
      this.pintaStars(noStars);
    },
    pintaStars(noStars) {
      if (noStars != undefined) {
        this.resetStars();
        for (var i = 0; i < noStars; i++) {
          this.stars[i] += " active";
        }
      }
    },
    resetStars() {
      this.stars = [
        "button small star-video tooltip tooltip-bottom",
        "button small star-video tooltip tooltip-bottom",
        "button small star-video tooltip tooltip-bottom",
        "button small star-video tooltip tooltip-bottom",
      ];
    },
    rollbackStars() {
      this.pintaStars(this.noStars);
    },
    setLike() {
      this.like = true;
      this.dislike = false;
      this.meh = false;
    },
    setDislike() {
      this.like = false;
      this.dislike = true;
      this.meh = false;
    },
    setMeh() {
      this.like = false;
      this.dislike = false;
      this.meh = true;
    },
    setLikes(type) {
      switch (type) {
        case 0:
          this.setDislike();
          break;
        case 1:
          this.setLike();
          break;
        case 2:
          this.setMeh();
          break;
      }
    },
    getTooltip(i) {
      var tooltip = "";
      switch (i) {
        case 1:
          tooltip = "Irrelevante";
          break;
        case 2:
          tooltip = "Poco Interesante";
          break;
        case 3:
          tooltip = "Relevante";
          break;
        case 4:
          tooltip = "Muy Relevante";
          break;
        default:
          break;
      }
      return tooltip;
    },
    getFecha(fecha) {
      moment.tz.setDefault("America/Mexico_City");
      var tmp = moment(fecha);
      var f = moment
        .tz(tmp, "America/Mexico_City")
        // .utc()
        // .local()
        .format("DD/MM/YYYY HH:mm:ss");
      return f;
    },
    enviar() {
      this.emailModal = true;
    },
    cancelarEnviar() {
      this.emailModal = false;
    },
    async sendEmail(obj) {
      var post_data = {
        token: this.token,
        nota: {
          fi: this.fi,
          key: this.id,
        },
        email: obj.email,
        type: "nota",
      };
      if (obj.subject != "") post_data["subject"] = obj.subject;

      if (obj.type == "correos") {
        if (obj.cc != "") {
          post_data["cc"] = obj.cc;
        }

        var self = this;

        axios
          .post(this.url + "sendMail", post_data)
          .then((response) => {
            self.emailModal = false;
            if (response.data.success) {
              self.success("Email enviado");
            } else {
              self.error(response.data.error);
            }
          })
          .catch(function (error) {
            self.error(response.data.error);
            console.log(error);
          });
      } else {
        post_data.type = "grupos";
        var r = await this.sendEmails(post_data);
        this.emailModal = false;
        if (r.success) {
          this.success("Email enviado");
        } else {
          this.error(r.error);
        }
      }
    },
    async sendEmails(obj) {
      var post_data = {
        nota: obj.nota,
        token: this.token,
        type: obj.type, //correo o grupos?
        typeObj: "nota",
        items: obj.email, //array de correos o grupos
      };

      if (obj.subject) post_data.subject = obj.subject;
      var self = this;
      return new Promise((resolve) => {
        axios
          .post(self.url + "sendEmails", JSON.stringify(post_data))
          .then(function (response) {
            // console.log(response);
            if (response.data.success) resolve({ success: true });
            else resolve({ success: false, error: response.data.error });
          })
          .catch(function (error) {
            resolve({ success: false, error: error });
          });
      });
    },
    // VIDEO PLAYER METHODS
    playerReadied(player) {
      if (this.item.entrada == "T" || this.item.entrada == "R") {
        var engine = player.tech_.hls || player.tech_.vhs;
        if (engine && engine.xhr) {
          engine.xhr.beforeRequest = function (options) {
            return options;
          };
        }
      }
    },
    onPlayerPlaying(player) {
      console.log(player, "#####==>")
      console.log(this.playerOptions);
      this.playing = true;
      var lengthOfVideo = player.duration();
      this.duracionVideoItem = lengthOfVideo;
      console.log(lengthOfVideo, "duracion del video");
      this.calcularFechas(lengthOfVideo);
    },
    playVideo() {
      this.activeVideo = true;
    },
    goBack() {
      var backData2 = this.$store.state.backData2;
      var data = backData2.pop();
      if (data == undefined) {
        this.$router.push("/main");
      } else {
        var from = data.from;
        var params = data.fromParams;

        this.$router.push({
          name: from,
          params: params,
        });
      }
    },
    goToNotes() {
      moment.tz.setDefault("America/Mexico_City");

      var tmp = moment(this.item.publicado_utc);

      var fecha = moment
        .tz(tmp, "America/Mexico_City")
        // .utc()
        // .local()
        .format("YYYY-MM-DD");
      var fechaC = new Date(this.item.publicado_utc);
      var query = {
        fi: {},
        keywords: [],
        ubicacion: "global",
        dias: "rango",
        fecha: {
          fin: fecha,
        },
        hora: {
          ini: "00:00",
          fin: "23:59",
        },
      };

      var arr = [];
      var codigo_noticiero =
        this.fi == "Y" ? this.item.key_src : this.item.codigo_noticiero;
      arr.push(codigo_noticiero);
      query.fi[this.fi] = arr;
      query.fiParams = {};
      query.fiParams[this.fi] = [1, 1];

      var p = {
        from: "notaVideo",
        fromParams: {
          fi: this.fi,
          id: this.id,
        },
        extraParams: {},
      };

      this.$store.commit("saveBack2", p);

      var p2 = {
        channel: this.item.noticiero.nombre,
        defaultImage: this.defaultImage,
        noticiero_imagen: this.item.noticiero.imagen,
        item: this.item,
        fechaC: fechaC,
      };

      this.$store.commit("saveNotasChannel", p2);

      this.$router.push({ name: "notas", params: { query: query } });
    },
    descargar() {
      console.log(this.item, "aqui item");
      var f = this.item.publicado.split(" ");
      var titulo = this.item.titulo.split(" ");
      var ti = "";
      for (let index = 0; index < 2; index++) {
        const element = titulo[index];
        if (ti == "") {
          ti = ti + element;
        } else {
          ti = ti + "_" + element;
        }
      }
      var tipo = this.item.entrada == "R" ? ".mp3" : ".mp4";
      var f2 = f[0].replace(/-/g, "");

      var canal = this.item.nombre_canal
        ? this.item.nombre_canal
        : this.item.noticiero.nombre;
      canal = canal.replace(/\//g, "_");

      var name = this.item.entrada + "-" + canal + "-" + f2 + "-" + ti + tipo;
      console.log(name);
      // console.log("Nombre ");
      // console.log(this.item);
      let str = this.item.titulo.replace(/\//g, "_");
      str = str.replace(/\s+/g, "_");
      str = str.replace(/\./g, "");
      str = str.substr(0, 100);
      // console.log(str);
      this.nombre_download = name; //this.item.claveorigen;
      this.isActive = true;
    },
    closeModal() {
      this.isActive = false;
    },
    download() {
      var c = this.changeOrigen
        ? this.item.metadatos.claveorigen
        : this.item.claveorigen;
      var claveSinCorte = this.item.claveorigen.split("-");
      console.log(c, "datos item");
      var arr = c.split("-");
      console.log("====CAMBIO DE ORIGEN===");
      console.log(this.changeOrigen);
      if (this.changeOrigen) {
        var conCorte = this.item.metadatos.claveorigen.split("-");

        this.markI = Math.floor(conCorte[4] - claveSinCorte[4]);
        //this.markI = this.markI - 5
        console.log(conCorte[4] + "-" + claveSinCorte[4]);
      } else {
        this.markI = Math.floor(claveSinCorte[4] - claveSinCorte[4]);

        // this.markI = this.markI- 5
        console.log(claveSinCorte[4] + "-" + claveSinCorte[4]);
      }

      /*var hst = this.$store.state.d8;
      var url = hst+"/hls/downloadNota.php?c="+this.item.claveorigen;
      console.log(url);
      window.location = url;*/
      if (this.nombre_download.trim() == "") {
        this.error("Ingrese un nombre");
        return 0;
      }

      var post_data = {
        token: this.token,
        key: this.id,
        nombre: this.nombre_download,
        inicio: this.markI,
        duracion: this.dur + 10,// + 30, //EGM 110224
      };

      if (this.markI == 0) {
        var d = arr[5].split("&");
        // console.log()
        // post_data.inicio = Math.floor(arr[4] + this.markI) "https://3ee40357kb.execute-api.us-east-1.amazonaws.com/dev/downloadnota",
        post_data.duracion = parseInt(d[0]) + 10;
      }
      var self = this;
      self.labelDescargar = "Procesado descarga..";
      console.log("====POST DATA====");
      console.log(post_data);
      axios({
        method: "post",
        url: this.url + "downloadnota", ///downloadNota Checar..
        data: post_data,
        timeout: 50000, // Aumenta el tiempo de espera a 10 segundos
      })
        .then((response) => {
          self.isActive = false;
          self.labelDescargar = "Descargar";
          if (response.data.success) {
            window.location.assign(response.data.data.link);
            this.$snotify.success("", "Descarga exitosa");
          }
        })
        .catch((error) => {
          console.log(error.response.status, "####error");
          if (error.code === "ECONNABORTED" || error.response.status === 504) {
            this.$snotify.info(
              "No se pudo realizar la descagar directamente.",
              "Tiempo excedido"
            );
            this.$snotify.info(
              "La descarga fue enviada a la carpeta de 'descargas'",
              "Enviando.."
            );
          } else {
            self.error("Ocurrió un error: " + error.message);
          }
          self.isActive = false;
          self.labelDescargar = "Descargar";
        });
    },
    parseFecha(fecha) {
      console.log(fecha);
      //fecha= "2020-02-06 16:13:12"
      moment.tz.setDefault("America/Mexico_City");

      var tmp = moment(fecha);

      var f = moment
        .tz(tmp, "America/Mexico_City")
        .format("DD/MM/YYYY HH:mm:ss");
      console.log(f);
      return f;
    },
    //comentarios
    showComentario() {
      this.showComment = true;
    },
    async addComment() {
      var post_data = {
        token: this.token,
        key: this.id,
        feed: this.fi,
        comentario: this.comment,
      };
      var self = this;
      axios
        .post(this.url + "addComment", post_data)
        .then((response) => {
          this.cleanComment();
          if (response.data.success) {
            var new_comment = response.data.data;
            this.comments.unshift(new_comment);
          }
        })
        .catch(function (error) {
          self.error(error);
        });
    },
    cleanComment() {
      this.comment = "";
    },
    setComment() {
      console.log("setComment");
    },
    eliminaComentario(comment, ndx) {
      this.commentKey = comment;
      this.commentIndex = ndx;
      smsModal: "¿Desea Eliminar éste comentario?", (this.showModal = true);
    },
    cancelar() {
      this.commentKey = null;
      this.commentIndex = null;
      this.showModal = false;
    },
    deleteComment() {
      this.isLoading = true;
      this.showModal = false;
      var post_data = {
        token: this.token,
        key: this.id,
        feed: this.fi,
        commentKey: this.commentKey,
      };
      var self = this;
      axios
        .post(this.url + "deleteComment", post_data)
        .then((response) => {
          self.isLoading = false;
          if (response.data.success) {
            self.success("Comentario Eliminado");
            self.comments.splice(self.commentIndex, 1);
            self.cancelar();
          } else {
            self.error(response.data.error);
          }
        })
        .catch(function (error) {
          self.isLoading = false;
          self.error(error, "Error");
        });
    },
    //cambiar poster de video
    changeImage() {
      this.$refs.posterVideo.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      var posterName = "";
      if (files[0] !== undefined) {
        posterName = files[0].name;

        if (posterName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);

        fr.addEventListener("load", () => {
          this.posterVideo = fr.result;
        });
      } else {
        this.posterVideo = "";
      }
    },
    async changeThumb() {
      var post_data = {
        token: this.token,
        providerID: this.providerID,
        data: {
          cmd: "editNote",
          fi: this.fi, //"FB"
          key: this.id, //"NoticierosTelevisacom-1007337109658149"
          imagen: this.thumb,
        },
      };
      var r = await this.editaNota(post_data);
      // console.log(r);
      if (r.success) {
        if (this.item.metadatos == undefined) this.item.metadatos = {};
        this.item.metadatos.imagen = this.thumb;
        this.playing = false;
        this.activeVideo = false;

        this.success(r.data);
      }
    },
    //screenshot
    takeSnap() {
      var player = this.$refs.videoNota.player;
      //console.log(this.$refs.videoNota.player);
      var containerVideo = this.$refs.containerVideo;
      ///var canvas = this.capture(player.width,player.height,player.children_[0]);
      var canvas = this.capture(
        containerVideo.clientWidth,
        containerVideo.clientHeight,
        player.el().children[0]
      );
      var dataUri = canvas.toDataURL("image/jpg");
      this.snapshot = dataUri;
      // console.log(dataUri);
    },
    capture(width, height, video, scaleFactor) {
      if (scaleFactor == null) {
        scaleFactor = 1;
      }
      var w = width * scaleFactor;
      var h = height * scaleFactor;
      var canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, w, h);
      return canvas;
    },
    saveSnap() {
      this.posterVideo = this.snapshot;
      this.snapshot = "";
      this.activeVideo = false;
      this.playing = false;
    },
    //para cortes de notas...
    setMarkIni() {
      console.log("setMarkIni");
      var player = this.$refs.videoNota.player;
      this.markI = parseInt(player.currentTime());
      this.calcularFechas(this.markI);
    },
    setMarkFin() {
      console.log("setMarkFin");
      var player = this.$refs.videoNota.player;
      this.markF = parseInt(player.currentTime());
      this.calcularFechas(this.markF);
    },

    calcularFechas(seconds) {
      var time = `00:00:00`;
      var fechaTime = new Date("1970-01-01T" + time);
      fechaTime.setSeconds(fechaTime.getSeconds() + seconds);
      var secondsC = fechaTime.toLocaleTimeString();
      var listSeconds = secondsC.split(":");
      console.log(secondsC, "calculando fecha");
      var hC = listSeconds[0] * 3600;
      var mC = listSeconds[1] * 60;
      var sC = listSeconds[2] * 1;

      return hC + mC + sC;
    },
    async optenerREstanteDuracionVideo() {
      console.log(this.playerOptions.sources[0].src, "player options");
      var urlV = this.playerOptions.sources[0].src;
      urlV = urlV.split("&");
      urlV = urlV[0].split("-");
      urlV = urlV[urlV.length - 1];
      console.log(urlV, "optenerREstanteDuracionVideo", this.duracionVideoItem);
      urlV = urlV - this.duracionVideoItem;
      console.log(urlV, "optenerREstanteDuracionVideo");
      // if(urlV < 0) {
      //   urlV = urlV * -1
      // }
      return urlV;
    },

    async cut() {
      console.log("marca inicial:", this.markI);
      console.log("marca final:", this.markF);

      if (this.markI == 0 && this.markF == 0) {
        this.error("Seleccione una marca inicial y final");
        return 0;
      }

      if (this.markI >= this.markF) {
        this.error("Marca inicial no puede ser mayor que la marca final");
        return 0;
      }

      this.isLoading = true;

      var dur = Math.floor(this.markF - this.markI); //- 37

      this.dur = dur;
      console.log("duracion:", dur);
      let cutd = {
        i: this.markI,
        d: dur,
      };

      this.$store.commit("setcut", cutd);

      var c = this.changeOrigen
        ? this.item.metadatos.claveorigen
        : this.item.claveorigen;

      var arr = c.split("-");

      // var inicio = (((Math.floor(arr[4]) - parseInt(10)) + this.markI));
      var inicio = Math.floor(arr[4]) + this.markI;
      if (inicio < 0) {
        inicio = 0;
      }
      // inicio = await this.obtenerTiempoEnSegundos(inicio);

      console.log(this.item.claveorigen, "clave de origen");
      console.log(arr[4], "array index 4");
      arr[4] = inicio;

      // console.log(resta, "===Resta");
      arr[5] = dur;
      // arr[5]=1;

      var c2 = arr.toString();

      console.log(c2, "C2====>");

      var claveorigen = c2.replace(/,/g, "-");

      console.log(claveorigen, "Clave origen ====>");

      var post_data = {
        token: this.token,
        providerID: this.providerID,
        data: {
          cmd: "editNote",
          fi: this.fi, //"FB"
          key: this.id, //"NoticierosTelevisacom-1007337109658149"
          claveorigen: claveorigen + "&cut=1",
        },
      };

      // console.log(post_data, "post_data");

      var r = await this.editaNota(post_data);
      // console.log("recortando", r);
      if (r.success) {
        this.playerOptions.sources[0].src =
          this.$store.getters.getVideoUrl + claveorigen + "&cut=1";
        console.log(this.$store.getters.getVideoUrl + claveorigen + "&cut=1");
        this.changeOrigen = true;
        this.activeVideo = false;
        this.playing = false;
        this.reload();
      }
      this.isLoading = false;
    },
    async undoVideoCut() {
      this.isLoading = true;
      var post_data = {
        token: this.token,
        providerID: this.providerID,
        data: {
          cmd: "editNote",
          fi: this.fi, //"FB"
          key: this.id, //"NoticierosTelevisacom-1007337109658149"
          claveorigen: this.item.claveorigen,
        },
      };
      var r = await this.editaNota(post_data);
      // console.log(r);
      if (r.success) {
        this.playerOptions.sources[0].src =
          this.$store.getters.getVideoUrl + this.item.claveorigen;
        this.changeOrigen = false;
        this.markI = 0;
        this.markF = 0;
      }
      this.isLoading = false;
    },
    cancelSnap() {
      this.snapshot = "";
    },
    setTooltip() {
      this.tooltip = true;
    },
    removeTooltip() {
      this.tooltip = false;
    },
    //compartir nota....
    compartir() {
      this.shareAlt = true;
    },
    cancelarShare() {
      this.shareAlt = false;
    },
    async share(opc) {
      this.shareAlt = false;
      var titulo = this.item.titulo;
      var descripcion = this.item.descripcion;
      var w = screen.width / 2;
      var h = screen.height / 2;
      var left = screen.width / 2 - w / 2;
      var top = screen.height / 2 - h / 2;
      var config =
        "menubar=no,location=yes,resizable=yes,scrollbars=no,status=yes, width=" +
        w +
        ",height=" +
        h +
        ",top=" +
        top +
        ",left=" +
        left;
      let popupWindow = null;

      var note_params = {
        table: this.getTable(this.item.entrada),
        key: this.item.key,
        token: this.token,
      };

      console.log(note_params, "note params");

      var urlShare = await this.getEncryptedUrl(note_params);
      console.log(urlShare,"5");
      switch (opc) {
        case "E": //email
          this.enviar();
          break;
        case "TW": //twitter
          var url = "https://twitter.com/intent/tweet/";
          var params = "?text=" + encodeURIComponent(titulo);
          params += "&url=" + encodeURIComponent(urlShare);
          popupWindow = window.open(url + params, "sharer", config);
          break;
        case "FB":
          var url = "https://www.facebook.com/sharer/sharer.php";
          var params = "?title=" + encodeURIComponent(titulo);
          params += "&u=" + encodeURIComponent(urlShare);
          params += "&description=" + encodeURIComponent(descripcion);
          popupWindow = window.open(url + params, "sharer", config);
          break;
        case "W":
          var url = "https://api.whatsapp.com/send";
          var contenido = this.getContent;

          var allContent = encodeURIComponent(contenido);
          var params = "?text=" + allContent;
          popupWindow = window.open(url + params, "sharer", config);
          break;
        default:
          break;
      }
    },
    getTable(fi) {
      var table = "";
      switch (fi) {
        case "T":
          table = "t_notas";
          break;
        case "R":
          table = "t_notas";
          break;
        case "FB":
          table = "t_facebook";
          break;
        case "Y":
          table = "t_youtube";
          break;
        case "I":
          table = "t_instagram";
          break;
        case "TW":
          table = "t_twitter";
          break;
        case "PD":
          table = "t_rss";
          break;
      }
      return table;
    },
    async getEncryptedUrl(post_data) {
      console.log("getEncryptedUrl");
      var self = this;
      return new Promise((resolve) => {
        axios
          .post(self.url + "getEncryptedUrl", post_data)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch(function (error) {
            self.error(error);
          });
      });
    },
    async redo() {
      //reestablcer nota a datos originales (quitar metadatos)
      this.isLoading = true;
      this.item.metadatos = {};

      var post_data = {
        token: this.token,
        providerID: this.providerID,
        data: {
          cmd: "removeMetadata",
          token: this.token,
          fi: this.fi, //"FB"
          key: this.id, //"NoticierosTelevisacom-1007337109658149"
        },
      };
      var r = await this.editaNota(post_data);
      // console.log(r);
      this.isLoading = false;
      if (r.success) {
        this.success("Edición Completa");

        this.reload();
      } else {
        this.error(r.error);
      }
    },

    error(msg) {
      this.$snotify.clear();
      this.$snotify.error(msg, this.$store.state.error);
    },
    success(msg) {
      this.$snotify.clear();
      this.$snotify.success(msg, this.$store.state.success);
    },
    // --------- copy to cliipboard ----------
    copy() {
      this.$refs.copyText.select();
      document.execCommand("copy");
      this.success("Copiado al portapapeles");
    },
    copiar(id) {
      var elementoParaCopiar = document.getElementById(id);
      var textoACopiar =
        elementoParaCopiar.textContent || elementoParaCopiar.innerText;

      // Crea un elemento de entrada de texto temporal
      var inputTemporal = document.createElement("input");
      inputTemporal.value = textoACopiar;

      // Agrega el elemento temporal al DOM
      document.body.appendChild(inputTemporal);

      // Selecciona el texto dentro del elemento de entrada de texto
      inputTemporal.select();
      inputTemporal.setSelectionRange(0, 99999); // Para dispositivos móviles

      // Copia el texto al portapapeles
      document.execCommand("copy");

      // Elimina el elemento de entrada de texto temporal
      document.body.removeChild(inputTemporal);

      this.success("Copiado al portapapeles");
    },
    menuVisible(menu) {
      this.menuOn = menu;
    },
    reload() {
      this.item = {};
      this.comments = [];
      this.activeVideo = false;
      this.playing = false;
      this.load();
    },
    async agregar_note_newsletter() {
      var table = this.getTable(this.item.entrada);

      var p = { from: "notaVideo", fromParams: { id: this.id, fi: this.fi } };
      this.$store.commit("saveBack2", p);

      this.$router.push({
        name: "agregarNotaNewsletter",
        params: { keyNote: this.item.key, table: table },
      });
    },
    async agregarItemnewsletter2() {
      this.isLoading = true;
      var table = this.getTable(this.item.entrada);
      var formQuery = {
        key: this.$store.state.userInfo.id,
        nota_id: this.item.key,
        table_nota: table,
      };
      await axios
        .post(this.url + "add_item_newsletter",
          formQuery
        )
        .then((response) => {
          if (response.data.success) {
            this.success(`Agregado correctamente a Newsletter`);
            // setTimeout(() => {
            //   this.goBack();
            // }, "1500");
          } else {
            this.error(response.data.body);
          }
        })
        .catch(function (error) {
          // console.log(error);
          this.error("Intente nuevamente");
        });
      this.isLoading = false;
    },
    async getPermisoNesletter() {
      var post_data = {
        id: this.$store.state.userInfo.id,
      };
     
      await axios
        .post(this.url + "permisonewsletter",
          post_data
        ) //petición
        .then((response) => {
          this.permissionsNewsletter = response.data;
        })
        .catch(function (error) { });
    },
    getVideoUrlVideo() {
     var c = this.changeOrigen
        ? this.item.metadatos.claveorigen
        : this.item.claveorigen;
        const originalString = c;
        const parts = originalString.split('-');
        const seconds = parseInt(parts[4]); // 29242
        const incrementValue = parseInt(parts[5]); // 84
        const newSeconds = seconds;
        const newIncrement = incrementValue;
        parts[4] = newSeconds.toString();
        parts[5] = newIncrement.toString();
        let newString = parts.join('-');
        newString = newString.split("&cut=")[0]
     
     
      console.log(this.$store.getters.getVideoUrl + newString)
      return this.$store.getters.getVideoUrl + newString;
      
    },
    getVideoUrlVideo1() {
      var c = this.changeOrigen
        ? this.item.metadatos.claveorigen
        : this.item.claveorigen;

      var arr = c.split("-");
      // console.log(c[0]);
      var incio = this.obtenerTiempoEnSegundos2(Math.floor(arr[4]));

      var to = arr[5].split("&");
      // var dur = Math.floor(to[0]) + 15;
      var dur = Math.floor(to[0]);

      var clave = this.item.medioTipo == "r" ? arr[1] : `${arr[1]}HI`;
      console.log(`https://d8.bdtr.net/hls/cls.m3u8?city=${arr[0]
        }&channel=${clave}&date=${this.armarFecha(
          this.item.fecha
        )}&time=${incio}&dur=${(dur + 77)}`)
      ////se cambio paul
      return `https://d8.bdtr.net/hls/cls.m3u8?city=${arr[0]
        }&channel=${clave}&date=${this.armarFecha(
          this.item.fecha
        )}&time=${incio}&dur=${(dur + 77)}`;
    },
    openAbstract() {
      this.abstractTxt = this.item.notaIA
        ? this.item.notaIA.resumen
        : "No contiene resumen";
      this.isAbstract = true;
    },
    openTranscription() {
      this.trascriptionTxt = this.item.notaIA
        ? this.item.notaIA.texto
        : "No contiene texto";
      this.isTranscription = true;
    },
    closeModalRe() {
      this.isAbstract = false;
    },
    closeModalTr() {
      this.isTranscription = false;
    },
  },
};
</script>

<style scoped>
.escondido {
  position: absolute;
  left: -1000px;
  top: -1000px;
}

#canvas {
  border: solid 1px blue;
  width: 100%;
  image-rendering: -moz-crisp-edges;
  /* Firefox */
  image-rendering: pixelated;
  /* Chrome */
  position: absolute;
}

.sub {
  color: #00b99e !important;
}

.specialPadding {
  padding: 8px 15px;
}

.back-button {
  padding: 0;
  width: 27px;
  height: 27px;
  border-radius: 5px;
}

.back-button:hover svg {
  fill: #fff;
}

.button.tooltip:after {
  z-index: 9999999999;
}

.link:hover {
  color: #00b99e;
}

.boxComments {
  max-height: 300px;
  width: 100%;
  overflow-y: scroll;
  scrollbar-width: thin;
  /* "auto" or "thin"  */
  scrollbar-color: #062633 #00b99e;
  word-wrap: break-word;
}

::-webkit-scrollbar {
  width: 12px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 3px #00b99e;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 3px #00b99e;
}

.cke_source {
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
}

.fName {
  width: 100%;
}

.trascripcion {
  width: 100%;
  /* Establece el ancho del div */
  height: 90%;
  /* Establece la altura del div */
  overflow: auto;
  /* Habilita la barra de desplazamiento si el contenido excede las dimensiones del div */
}
</style>
